var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pricing-curve--blurred"},[_c('img',{attrs:{"src":`${_vm.baseUrl}images/blurredcurve.jpg`,"alt":"Blurred Pricing Curve"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }